let count = 0;
import $ from 'jquery';

$('.tabs-countries h3').click(function () {
  var lastPopupMarker = $('.popup-marker').last();

  var lastPopupMarkerHeight = lastPopupMarker.height();

  var tabsCountries = $('.tabs-countries');
  var popups = $('.popups');
  if (tabsCountries.length) {
    var lastPopupMarkerTop = lastPopupMarker.offset().top;
    var tabsCountriesTop = tabsCountries.offset().top;
  }

  count = 0;
  // Rimuovi la classe "active" da tutti gli elementi "h3" con classe "active".
  $('.tabs-countries h3.active').removeClass('active');

  // Aggiungi la classe "active" all'elemento "h3" che è stato cliccato.
  $(this).addClass('active');

  // Ottieni il valore dell'attributo "data-filter" dell'elemento "h3" che è stato cliccato.
  var dataFilter = $(this).attr('data-filter');

  // Nascondi tutti gli elementi con classe "popup-marker".
  $('.popup-marker').hide();

  // Trova tutti gli elementi con classe "popup-marker" che hanno il valore dell'attributo "data-area" uguale al valore dell'attributo "data-filter" dell'elemento "h3" che è stato cliccato, e mostra questi elementi.
  $('.popup-marker[data-area="' + dataFilter + '"]').fadeIn();

  // conta gli elementi con stile "display: block"
  const elements = document.querySelectorAll('.popup-marker');
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    const style = getComputedStyle(element);
    if (style.display === 'block') {
      count++;
    }
  }
});

var lastPopupMarker = $('.popup-marker').last();

var lastPopupMarkerHeight = lastPopupMarker.height();

var tabsCountries = $('.tabs-countries');
var popups = $('.popups');
if (tabsCountries.length) {
  var lastPopupMarkerTop = lastPopupMarker.offset().top;
  var tabsCountriesTop = tabsCountries.offset().top;
}

const elements = document.querySelectorAll('.popup-marker');
if (elements.length) {
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    const style = getComputedStyle(element);
    if (style.display === 'block') {
      count++;
    }
  }
}

function positionTabsCountries() {
  /*   var windowWidth = $(window).width();
  if (windowWidth > 999) {
    var scrollTop = $(window).scrollTop();
    if (
      scrollTop + 75 > tabsCountriesTop &&
      count > 2 &&
      scrollTop - lastPopupMarkerHeight < lastPopupMarkerTop
    ) {
      tabsCountries.addClass('fixed');
      popups.addClass('more-left');
    } else {
      tabsCountries.removeClass('fixed');
      popups.removeClass('more-left');
    }
  } else {
    tabsCountries.removeClass('fixed');
    popups.removeClass('more-left');
  } */
}

// Posiziona l'elemento all'avvio e al ridimensionamento della finestra del browser
if (tabsCountries.length) {
  $(window).on('load resize', positionTabsCountries);
  $(window).on('scroll', positionTabsCountries);
}
